import React from "react";
import HomePageLayout from "../../layouts/HomepageLayout";
import PagesTop from "../../components/Frontend/PagesTop.jsx";
import faqBg from "../../styles/bgs/faq-bg.jpg";

const Contact = () => {
  return (
    <HomePageLayout>
      <PagesTop title="CONTACT" link="Contact Us" bg={faqBg} />
      <div className="contact">
        <div className="contact-wrapper">
          <div className="contact-message">
            <h3 className="fw-bold">Get in touch with Us</h3>
            <p>Fill the contact form below to reach out to us</p>
            <form className="contact-form">
              <div className="contact-group">
                <div className="contact-item">
                  <label htmlFor="name">Your Name:</label>
                  <input
                    type="text"
                    id="name"
                    placeholder="Full Name"
                    required
                  />
                </div>
                <div className="contact-item">
                  <label htmlFor="email">Your Email:</label>
                  <input type="email" id="email" placeholder="Email" required />
                </div>
              </div>

              <div className="contact-group">
                <div className="contact-item">
                  <select
                    name="subject"
                    id="contact-subject"
                    placeholder="Please seleect your Subject"
                    required
                  >
                    <option value="Select Subject" id="topic-not-selected">
                      Select your Subject
                    </option>
                    <option value="Affiliates &amp; Advertisers">
                      Affiliates &amp; Advertisers
                    </option>
                    {/* <option value="Forgot withdraw PIN">Forgot withdraw PIN</option> */}
                    <option value="Financial questions">
                      Financial questions
                    </option>
                    <option value="Technical problems">
                      Technical problems
                    </option>
                    <option value="Help with funding">Help with funding</option>
                    <option value="Other Funding">Other Funding</option>
                    <option value="Account update">Account update</option>
                    <option value="Withdrawal">Withdrawal</option>
                    <option value="Site Review">Send a review</option>
                    <option value="More Inquiries">More Inquiries</option>
                  </select>
                </div>
                <div className="emotes contact-item">
                  <ul className="button-group">
                    <li>
                      <i className="far fa-angry"></i>
                    </li>
                    <li>
                      <i className="far fa-meh"></i>
                    </li>
                    <li>
                      <i className="far fa-smile"></i>
                    </li>
                    <li>
                      <i className="far fa-laugh"></i>
                    </li>
                    <li>
                      <i className="far fa-grin-stars"></i>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="contact-group">
                <div className="message contact-item">
                  <label htmlFor="message">Your Message:</label>
                  <textarea
                    name="message"
                    id=""
                    rows="3"
                    placeholder="Write your message"
                    maxLength="1024"
                    required
                  ></textarea>
                </div>
              </div>
              <div className="submit-box">
                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </div>
            </form>
          </div>

          <div className="contact-address">
            <div className="con-add-header">
              <h3 className="fw-bold">Contact Us</h3>
              <h4>Our Head Office</h4>
              <p className="">
                With headquaters in California and offices in London, Cairo and
                Hong Kong our global presence brings us in direct contact with
                clients and offers an exceptional network of opportunities
                across our diverse investment portfolio. Feel free to visit any
                of our offices closest to you.
              </p>
            </div>
            <div className="address">
              <div className="address-box">
                <h4>California</h4>
                <p>
                  <i className="fas fa-map-marker-alt"></i> 21300 Victory Blvd
                  #100, Woodland Hills, CA 91367, United States
                </p>
              </div>
              {/* <div className="address-box">
                <h4>London</h4>
                <p>
                  <i className="fas fa-map-marker-alt"></i> 63 Brook Street
                  London W1K 4HS United Kingdom +44 20 7078 1299
                </p>
              </div>
              <div className="address-box">
                <h4>Hong Kong</h4>
                <p>
                  <i className="fas fa-map-marker-alt"></i> Unit 3312, 33/F, The
                  Center 99 Queen’s Road Hong Kong +852 3911 0880
                </p>
              </div>
              <div className="address-box">
                <h4>Cairo</h4>
                <p>
                  <i className="fas fa-map-marker-alt"></i> B16, Smart Village,
                  Km 28 Cairo Alex Desert Road Giza, Egypt +202 353 70 555
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </HomePageLayout>
  );
};

export default Contact;
